/**
 * EPI Create Page
 * Page for creating new EPI
 *
 * @version 2025.1.0
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  Alert,
} from '@mui/material';
import { PageShell } from '../../components';
import { epiService } from '../../services/epiService';
import { EpiFormData } from '../../types/epi';
import { EPIFormWizard } from './components';

export const EPICreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: EpiFormData) => {
    try {
      setIsSubmitting(true);
      setError(null);
      await epiService.createEpi(data);
      navigate('/epis');
    } catch (err: unknown) {
      const error = err as { message?: string };
      setError(error.message ?? 'Erro ao criar EPI');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/epis');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'EPIs', path: '/epis' },
        { label: 'Novo EPI' },
      ]}
      title="Cadastrar Novo EPI"
      subtitle="Preencha os dados do Equipamento de Proteção Individual"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <Card>
        <CardHeader title="Cadastro de EPI" />
        <CardContent>
          <EPIFormWizard
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isSubmitting={isSubmitting}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default EPICreatePage;
